import { Link } from 'gatsby'
import React, { useRef } from 'react'
import { useOnClickOutside } from '../hooks/useOnClickOutside'

import './styles/FlyoutMenu.css'

const FlyoutMenu = ({ isOpen, clickHandler }) => {
  const ref = useRef(null)

  useOnClickOutside(ref, () => {
    clickHandler(false)
  })

  return (
    <div ref={ref} className={`flyout-menu ${isOpen ? 'show' : 'hide'}`}>
      <i
        class="fas fa-times flyout-close"
        onClick={() => {
          clickHandler(false)
        }}
      ></i>
      <div className="flyout-content">
        <p>
          <Link to="/">Home</Link>
        </p>
        <p>
          <Link to="/games">Games</Link>
        </p>
        <p>
          <Link to="/consoles">Consoles</Link>
        </p>
        <p>
          <Link to="/faq">FAQ's</Link>
        </p>
        {/* <p>
                    <Link to='/testimonials'>Customer Testimonials</Link>
                </p> */}
      </div>

      <div className="contact-us">
        <Link
          target="_blank"
          to="https://www.instagram.com/nintendo_india_store/"
        >
          <i className="fab fa-instagram instagram-icon"></i>
        </Link>
      </div>
    </div>
  )
}

export default FlyoutMenu
